import React from "react";
import PopAdminPresenter from "@/presenters/screens/pop-admin.presenter";
import { SingleCollapse } from "@/components/";
import Mri from "./mri/Mri";
import Objetives from "./objetives/Objetives";

export interface IPropsStep {
	columns: any;
	data: any;
}

const Step4: React.FC<IPropsStep> = ({ columns, data }: IPropsStep) => {

	const view: any = {
        state: {
        },
    };
      
    const presenter = new PopAdminPresenter(view);

	return (
		<>
			<SingleCollapse title={presenter.currentLabels.get("proaResultadosIntermedios")} isOpen={false}>
				<SingleCollapse
					title={presenter.currentLabels.get("proaFEAdaptaciónIndicadoresMRI")}
					isOpen={false}
				>
					<Mri columns={columns} data={data?.mri} />
				</SingleCollapse>

				<SingleCollapse
					title={presenter.currentLabels.get("proaFEObjetivosEspecíficos")}
					isOpen={false}
				>
					{!!data?.objetives &&
						data.objetives?.map((obj: any) => {
							return (
								<Objetives columns={columns} data={obj} key={obj.genericInfo.Id} />
							);
						})
					}
				</SingleCollapse>
			</SingleCollapse>
		</>
	);
};

export default Step4;
